export class AnalyticsUrlConfigDto {
    constructor(token, uiUrl) {
      this.token = token;
      this.uiUrl = uiUrl;
    }
}